import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DateRangeSelects, UniversalSelect } from '@feathr/components';
import type { IDateRangeOption } from '@feathr/extender/hooks';
import { flattenError } from '@feathr/hooks';

interface IProps {
  customDateRange: [string | undefined, string | undefined];
  dateRangeOptions: IDateRangeOption[];
  onDateRangeChange: (option: IDateRangeOption) => void;
  onCustomDateRangeChange: (value: [string | undefined, string | undefined]) => void;
  selectedDateRange: string;
  validationError: string[] | undefined;
}

function DateRangeSelect({
  customDateRange,
  dateRangeOptions,
  onDateRangeChange,
  onCustomDateRangeChange,
  selectedDateRange,
  validationError,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <UniversalSelect<IDateRangeOption>
        label={t('Date range')}
        name={'date_range'}
        onSelectSingle={onDateRangeChange}
        options={dateRangeOptions}
        validationError={flattenError(validationError)}
        value={dateRangeOptions.find((opt) => opt.id === selectedDateRange)}
      />
      {selectedDateRange === 'custom' && (
        <DateRangeSelects onChange={onCustomDateRangeChange} t={t} value={customDateRange} />
      )}
    </>
  );
}

export default DateRangeSelect;
